import angular from 'angular';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { Angular as AngularIntegration } from '@sentry/integrations';

Sentry.init({
  dsn: 'https://fff168f96af44b30a20755a3caa2a05e@o1074132.ingest.sentry.io/6073755',
  integrations: [
    new AngularIntegration(),
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'https://underwraps.app/api'],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

import angularUiMask from 'angular-ui-mask';

// App modules
import appHome from './pages/home/home.index';
import appMe from './pages/me/me.index';
import bedfordList from './pages/bedford-list/bedford-list.index';
import appPeeps from './pages/peeps/peeps.index';
import appGiftList from './pages/gift-list/gift-list.index';
import appGiftDeets from './pages/gift-deets/gift-deets.index';
import settings from './pages/settings/settings.index';
import login from './pages/login/login.index';
import resetPassword from './pages/reset-password/reset-password.index';
import changePassword from './pages/change-password/change-password.index';

import shared from './shared/shared.index';

// App styles
import './app.scss';

// Create app module
var app = angular.module('underwraps', [
  'ui.router',
  'ngMockE2E',
  'ngResource',
  'ngSanitize',
  'ngSentry',
  angularUiMask,

  'angular-loading-bar',
  shared,
  appHome,
  appMe,
  bedfordList,
  appGiftList,
  appPeeps,
  appGiftDeets,
  settings,
  login,
  resetPassword,
  changePassword,
]);

app.service('authInterceptor', [
  '$q',
  '$location',
  '$rootScope',
  'LoginService',
  function ($q, $location, $rootScope, LoginService) {
    var service = this;

    service.responseError = function (response) {
      if (response.status == 401 && response.config.url !== '/api/login') {
        $location.path('/login');
        $rootScope.$broadcast('force-check-auth');
        LoginService.showLogin(null);
      }
      return $q.reject(response);
    };
  },
]);

app.config([
  '$httpProvider',
  'cfpLoadingBarProvider',
  function ($httpProvider, cfpLoadingBarProvider) {
    $httpProvider.interceptors.push('authInterceptor');
    cfpLoadingBarProvider.includeBar = false;
  },
]);

app.controller('HeaderController', [
  '$timeout',
  '$scope',
  'CurrentUserService',
  'UserAccountService',
  '$state',
  function ($timeout, $scope, CurrentUserService, UserAccountService, $state) {
    this.getFirstName = function () {
      if (CurrentUserService.currentUser) {
        return CurrentUserService.currentUser.name;
      }
    };

    this.showChristmasList = !document.location.href.includes('joy');

    this.isLoggedIn = function () {
      return CurrentUserService.isLoggedIn;
    };
    this.logout = function () {
      UserAccountService.logout().then(function (data) {
        FS.identify(false);
        $state.go('home');
        CurrentUserService.checkAuth(true);
      });
    };

    $scope.$on('force-check-auth', function () {
      CurrentUserService.checkAuth(true);
    });
  },
]);
